export const ProductDetailBrand: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="row-start-2 flex flex-col lg:col-start-1 lg:row-start-1">
      {children}
    </div>
  );
};

export const ProductDetailTop: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="flex max-w-[90vw] flex-col justify-center gap-2.5 justify-self-center text-center xmd:max-w-none lg:col-start-2 lg:max-w-none lg:justify-start lg:justify-self-start lg:text-left">
      {children}
    </div>
  );
};

export const ProductDetailMedia: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="flex justify-center lg:col-start-1 lg:justify-start">
      {children}
    </div>
  );
};

export const ProductDetailActions: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="mt-6 flex flex-col items-center gap-y-9 lg:gap-y-5">
      {children}
    </div>
  );
};

export const ProductDetailSelector: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="mx-12 flex w-full flex-col items-center justify-center gap-5 lg:col-start-2 lg:justify-start lg:border lg:border-gray200 lg:px-2.5 lg:py-2.5">
      {children}
    </div>
  );
};

export const ProductDetailTopPilot: React.FC<
  React.PropsWithChildren<{ isShown?: boolean }>
> = ({ isShown = true, children }) => {
  if (!isShown) return null;

  return (
    <div className="flex min-h-8 justify-center xsm:mx-auto lg:ml-[-30px] lg:justify-start">
      {children}
    </div>
  );
};

export const ProductDetail: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="grid w-full grid-cols-1 grid-rows-[minmax(0,max-content)] gap-x-2.5 gap-y-4 lg:mt-[36px] lg:grid-cols-2">
      {children}
    </div>
  );
};

export const ProductValuePropIcons: React.FC = () => {
  return (
    <div className="w-full py-8 lg:ml-auto lg:w-1/2 lg:px-[48px]">
      <div className="flex gap-x-2.5">
        <figure className="flex w-full flex-col items-center  gap-y-2">
          <svg className="h-9 w-10 pt-2">
            <use xlinkHref="/frontend-assets/images/icons.svg#shipping"></use>
          </svg>
          <figcaption className="text-center text-sm">Fast Shipping</figcaption>
        </figure>
        <figure className="flex w-full flex-col items-center gap-y-2">
          <svg className="h-9 w-10">
            <use xlinkHref="/frontend-assets/images/icons.svg#returns"></use>
          </svg>
          <figcaption className="text-center text-sm">
            60 Day Returns
          </figcaption>
        </figure>
        <figure className="flex w-full flex-col items-center gap-y-2">
          <svg className="h-9 w-[26px] pt-1">
            <use xlinkHref="/frontend-assets/images/icons.svg#service"></use>
          </svg>
          <figcaption className="text-center text-sm">
            Service Guarantee
          </figcaption>
        </figure>
      </div>
    </div>
  );
};

export const ProductBlocks: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="flex w-full flex-col gap-x-6 gap-y-10 lg:flex-row-reverse">
      {children}
    </div>
  );
};

export const ProductBlockTrustpilot: React.FC<
  React.PropsWithChildren<{ isShown?: boolean }>
> = ({ isShown = true, children }) => {
  if (!isShown) return null;

  return (
    <div className="w-full bg-blue100 px-5 py-10 lg:w-1/2">{children}</div>
  );
};

export const ProductBlockDescription: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="min-h-[200px] w-full bg-blue100 lg:w-1/2">{children}</div>
  );
};
